// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lnJe","label":"styles_label__zw04b"};